module.exports = __webpack_public_path__ + "static/media/cal.1fefd4f3.svg";